export default import.meta.ROLLUP_FILE_URL_FGLc8zCF;